import { render } from "./Tab2.vue?vue&type=template&id=69bde848&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"

import "./Tab2.vue?vue&type=style&index=0&id=69bde848&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bde848"]])

export default __exports__